module.exports = __webpack_public_path__ + "img/slide7.2ed4afd2.jpg";